import { SubNavLayout } from "@/components/SubNavLayout"
import { PATHS, SHARING_PATHS } from "@/routing/paths"

import { FormattedMessage } from "react-intl"
import { Navigate, Route, Routes } from "react-router-dom"
import { InterBU } from "./tabs/InterBU"
import { People } from "./tabs/People"
import { Project } from "./tabs/Project"

export const Shares: React.FC = () => {
  return (
    <SubNavLayout title={<FormattedMessage id="sharing" />}>
      <Routes>
        <Route
          index
          element={<Navigate to={`${PATHS.SHARING}${SHARING_PATHS.INTER_BU}`} replace />}
        />
        <Route path={`${SHARING_PATHS.INTER_BU}/*`} element={<InterBU />} />
        <Route path={SHARING_PATHS.PEOPLE} element={<People />} />
        <Route path={SHARING_PATHS.PROJECT} element={<Project />} />
      </Routes>
    </SubNavLayout>
  )
}
